import { ResultKind, SmartSearchSelectOption } from '@/components/SmartSearch';

import { getElectrolyteBaseUrl } from '../urls';
import i18n from '@/i18n';

const electrolyteBaseUrl = getElectrolyteBaseUrl();

export const getInternalPages = (): SmartSearchSelectOption[] => [
  {
    kind: ResultKind.PAGE_NAVIGATION,
    text: i18n.t('common:constants.smartSearch.pages.devices.text'),
    url: `${electrolyteBaseUrl}/device-overview`,
    description: i18n.t(
      'common:constants.smartSearch.pages.devices.description'
    ),
    keywords: ['device', 'security'],
    isDefaultOption: true,
    isVisibleToEndUser: false,
  },
  {
    kind: ResultKind.PAGE_NAVIGATION,
    text: i18n.t('common:constants.smartSearch.pages.activeEmployees.text'),
    url: `${electrolyteBaseUrl}/active-employees`,
    description: i18n.t(
      'common:constants.smartSearch.pages.activeEmployees.description'
    ),
    keywords: ['onboard', 'offboard', 'info', 'license', 'hris', 'device'],
    isDefaultOption: true,
    isVisibleToEndUser: false,
  },
  {
    kind: ResultKind.PAGE_NAVIGATION,
    text: i18n.t('common:constants.smartSearch.pages.discover.text'),
    url: `${electrolyteBaseUrl}/discover`,
    description: i18n.t(
      'common:constants.smartSearch.pages.discover.description'
    ),
    keywords: ['partner', 'marketplace', 'learn'],
    isDefaultOption: true,
    isVisibleToEndUser: false,
  },
  {
    kind: ResultKind.PAGE_NAVIGATION,
    text: i18n.t('common:constants.smartSearch.pages.billing.text'),
    url: `${electrolyteBaseUrl}/settings/billing`,
    description: i18n.t(
      'common:constants.smartSearch.pages.billing.description'
    ),
    keywords: ['payment', 'invoice', 'subscription', 'license'],
    isVisibleToEndUser: false,
  },
  {
    kind: ResultKind.PAGE_NAVIGATION,
    text: i18n.t('common:constants.smartSearch.pages.mdmSetup.text'),
    url: `${electrolyteBaseUrl}/settings/device`,
    description: i18n.t(
      'common:constants.smartSearch.pages.mdmSetup.description'
    ),
    keywords: ['download', 'install'],
    isVisibleToEndUser: false,
  },
  {
    kind: ResultKind.PAGE_NAVIGATION,
    text: i18n.t('common:constants.smartSearch.pages.applications.text'),
    url: `${electrolyteBaseUrl}/applications`,
    description: i18n.t(
      'common:constants.smartSearch.pages.applications.description'
    ),
    keywords: ['app', 'application', 'champion'],
    isDefaultOption: true,
    isVisibleToEndUser: false,
  },
  {
    kind: ResultKind.PAGE_NAVIGATION,
    text: i18n.t('common:constants.smartSearch.pages.employeeGroups.text'),
    url: `${electrolyteBaseUrl}/groups`,
    description: i18n.t(
      'common:constants.smartSearch.pages.employeeGroups.description'
    ),
    keywords: [],
    isDefaultOption: true,
    isVisibleToEndUser: false,
  },
  {
    kind: ResultKind.PAGE_NAVIGATION,
    text: i18n.t('common:constants.smartSearch.pages.hardware.text'),
    url: `${electrolyteBaseUrl}/get-hardware`,
    description: i18n.t(
      'common:constants.smartSearch.pages.hardware.description'
    ),
    keywords: ['assign', 'purchase', 'buy', 'device', 'procurement'],
    isDefaultOption: true,
    isVisibleToEndUser: false,
  },
  {
    kind: ResultKind.PAGE_NAVIGATION,
    text: i18n.t('common:constants.smartSearch.pages.notifications.text'),
    url: `${electrolyteBaseUrl}/notification-center`,
    description: i18n.t(
      'common:constants.smartSearch.pages.notifications.description'
    ),
    keywords: [],
    isVisibleToEndUser: true,
  },
  {
    kind: ResultKind.PAGE_NAVIGATION,
    text: i18n.t(
      'common:constants.smartSearch.pages.supportTicketRouting.text'
    ),
    url: `${electrolyteBaseUrl}/settings/category-champions`,
    description: i18n.t(
      'common:constants.smartSearch.pages.supportTicketRouting.description'
    ),
    keywords: ['champion', 'help desk'],
    isVisibleToEndUser: false,
  },
  {
    kind: ResultKind.PAGE_NAVIGATION,
    text: i18n.t('common:constants.smartSearch.pages.requests.text'),
    url: `${electrolyteBaseUrl}/support-center`,
    description: i18n.t(
      'common:constants.smartSearch.pages.requests.description'
    ),
    keywords: ['ask a question', 'get help'],
    isDefaultOption: true,
    isVisibleToEndUser: true,
  },
  {
    kind: ResultKind.PAGE_NAVIGATION,
    text: i18n.t('common:constants.smartSearch.pages.helpfulLinks.text'),
    url: `${electrolyteBaseUrl}/helpful-links`,
    description: i18n.t(
      'common:constants.smartSearch.pages.helpfulLinks.description'
    ),
    keywords: [],
    isDefaultOption: true,
    isVisibleToEndUser: true,
  },
  {
    kind: ResultKind.PAGE_NAVIGATION,
    text: i18n.t('common:constants.smartSearch.pages.gigawatt.text'),
    url: `${electrolyteBaseUrl}/AIChat`,
    description: i18n.t(
      'common:constants.smartSearch.pages.gigawatt.description'
    ),
    keywords: ['chat', 'bot', 'ask a question', 'get help'],
    isDefaultOption: true,
    isVisibleToEndUser: true,
  },
];
